
import "./maxxa.css"
import productos from "../lensun/lensun principal/principla/len"

function Maxxa(){
    return(
        <>
       
      
    <body className="maxxa">
    <section className="fotosMaxxa">
 <a href="/maxxa"><img className="maxxaTop" src="https://firebasestorage.googleapis.com/v0/b/lensuncaba.appspot.com/o/logos%20marcar%2Flogomaxxa3.png?alt=media&token=1100e852-4a7e-4e92-9cf8-578dd6b27ff6"/></a>

      <br></br>
      <div class="container px-4 px-lg-5 mt-5">
            <div class="row gx-4 gx-lg-5 row-cols-2 row-cols-md-3 row-cols-xl-4 justify-content-center">
                <div class="col mb-5">
                  <div className="backMaxxa"> 
                    <div class="card h-100">
                        <img class="card-img-top" src="https://firebasestorage.googleapis.com/v0/b/lensuncaba.appspot.com/o/maxxa%2Fauriculares%2FM33%20X4.jpg?alt=media&token=2a9e8043-0ddc-402b-89a7-382bc3dc4845" /> 
                        <div class="card-body p-4">
                          <div class="text-center">
                            <h5 class="fw-bolder">M 33</h5>
                           
                           </div>
                        </div>
                        </div>  
                        
                    </div>
                </div>
                <div class="col mb-5">
                  <div className="backMaxxa"> 
                    <div class="card h-100">
                        <img class="card-img-top" src="https://firebasestorage.googleapis.com/v0/b/lensuncaba.appspot.com/o/maxxa%2Fauriculares%2Fm45%20negro.jpg?alt=media&token=e90e1ac2-af76-4681-ac1e-56ffd9120d35" /> 
                        <div class="card-body p-4">
                          <div class="text-center">
                            <h5 class="fw-bolder">M 45</h5>
                           
                           </div>
                        </div>
                        </div>  
                        
                    </div>
                </div>
                <div class="col mb-5">
                <div className="backMaxxa">
                    <div class="card h-100">
                        <img className="card-img-top" src="https://firebasestorage.googleapis.com/v0/b/lensuncaba.appspot.com/o/maxxa%2Fcargadores%2Fc1%20caja.jpg?alt=media&token=862d882d-e501-4d18-bda0-5f46bde324e0" alt="..." />
                        <div class="card-body p-4">
                          <div class="text-center">
                            <h5 class="fw-bolder">Cargador Maxxa 2A</h5>
                            
                           </div>
                        </div>
                       </div>
                       
                    </div>
                </div>
                <div class="col mb-5">
                <div className="backMaxxa">
                    <div class="card h-100">
                        <img className="card-img-top" src="https://firebasestorage.googleapis.com/v0/b/lensuncaba.appspot.com/o/maxxa%2Fcargadores%2Fc3.2%20caja.jpg?alt=media&token=5e96e591-895f-4c6e-bdbc-66261d8ccc06" alt="imagen de back" />
                        <div class="card-body p-4">
                          <div class="text-center">
                            <h5 class="fw-bolder">Cargador Carga Rapida</h5>
                          
                           </div>
                        </div>
                       
                        </div>
                    </div>
                </div>
                <div class="col mb-5">
                <div className="backMaxxa">
                    <div class="card h-100">
                        <img class="card-img-top" src="https://firebasestorage.googleapis.com/v0/b/lensuncaba.appspot.com/o/maxxa%2Fcargadores%2FCA12.jpg?alt=media&token=20a21dbb-0495-47ff-95e4-5bd13c5e279b" alt="..." />
                        <div class="card-body p-4">
                          <div class="text-center">
                            <h5 class="fw-bolder">CA12 Cardor Auto</h5>
                          
                           </div>
                        </div>
                       </div>
                        
                    </div>
                </div><div class="col mb-5">
                <div className="backMaxxa">
                    <div class="card h-100">
                        <img class="card-img-top" src="https://firebasestorage.googleapis.com/v0/b/lensuncaba.appspot.com/o/maxxa%2Fvarios%2FP16%20MILITAR.jpg?alt=media&token=3f888c39-63ad-4a66-b65f-b6bb13f378cb" alt="..." />
                        <div class="card-body p-4">
                          <div class="text-center">
                            <h5 class="fw-bolder">P16</h5>
                            
                           </div>
                        </div>
                       
                        </div>
                    </div>
                </div>
                <div class="col mb-5">
                <div className="backMaxxa">
                    <div class="card h-100">
                        <img class="card-img-top" src="https://firebasestorage.googleapis.com/v0/b/lensuncaba.appspot.com/o/maxxa%2Fvarios%2Fm115%20caja.jpg?alt=media&token=4ed67cb6-8c3c-470b-9c1b-f517a4f83b04" alt="..." />
                        <div class="card-body p-4">
                          <div class="text-center">
                            <h5 class="fw-bolder">M115</h5>
                           
                           </div>
                        </div>
                       
                        </div>
                    </div>
                </div>
                </div>
                </div>      
    </section>
 </body>   

 </>
    )
}

export default Maxxa